// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"c04eefbc","629":"a6fc9f5f","737":"53672247","869":"d1c6690c","965":"49468fe0"}[chunkId] + ".chunk.js";
};